<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbMission } from '@/models/alodb/AloDbMission'
import AdminMissionPlan from '@/components/admin/adminMission/AdminMissionPlan.vue'
import AdminForm from '@/components/admin/AdminForm.vue'


@Component({
  name: 'AdminMissionPlanTab', 
  components:{AdminMissionPlan}
})
export default class AdminUser extends AdminForm<AloDbMission> {    
  get itemTypeName(){
    return "AdminMission"
  }

  get componentName(){
    return "AdminMissionPlan"
  }

  get showActionArea() {
    return true
  }

  get showTitle(){
    return false
  }
  
  
}
</script>